exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Custom-Slider:before{width:100%;height:100%;content:\"\";position:absolute;left:0;top:0;pointer-events:none;background:rgba(147,0,17,.75);background:-webkit-gradient(left top,right bottom,color-stop(0,rgba(135,183,125,.5)),color-stop(100%,rgba(74,132,62,.5)));background:linear-gradient(135deg,rgba(135,183,125,.5),rgba(74,132,62,.5));filter:progid: DXImageTransform.Microsoft.gradient(startColorstr=\"#87b77d\",endColorstr=\"#4a833e\",GradientType=1);z-index:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-774c04e2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/slider/CustomSlider.vue
// module id = 282
// module chunks = 0